export default function (path, locale) {
  const localeReg = new RegExp('^' + locale + '/')
  const careersReg = /^careers/
  const endReg = /\/$/

  if (path) {
    return path.replace(/^\//, '').replace(localeReg, '').replace(careersReg, '').replace(endReg, '')
  }

  return ''
}
